import { FC } from 'react';
import { Anchor, AnchorModel, Link, Text } from '@bpba/ui-components';
import { LEGALES_LINK, LEGALES_TEXTO } from '../../constants/data';
import { BackgroundColorProps } from 'styled-system';
import { ModuleContainerGeneric } from '@bpba/modules-components';
import { AuthenticationHOC } from '../shared/authenticacion/AuthenticationHOC';

const legalesLink = LEGALES_LINK
  ? new AnchorModel(0, undefined, new Link(LEGALES_LINK.ruta, LEGALES_LINK.isExterno, LEGALES_LINK.abreSolapa, LEGALES_LINK.tag))
  : undefined;

export const Legales: FC<BackgroundColorProps> = (props) => {
  return (
    <AuthenticationHOC showOnLogin={false}>
      <ModuleContainerGeneric
        paddingTop={['16px !important']}
        paddingBottom={['16px !important']}
        justifyContent="center"
        display="flex"
        {...props}
      >
        <Anchor data={legalesLink} display="flex">
          <Text
            fontSize={['14px', null, null, '16px']}
            lineHeight={['18px', '24px']}
            textAlign={'center'}
            fontWeight="500"
            marginX="auto"
            marginY="0px"
            color="primary.0"
            margin={'auto'}
            dangerouslySetInnerHTML={{ __html: LEGALES_TEXTO }}
          />
        </Anchor>
      </ModuleContainerGeneric>
    </AuthenticationHOC>
  );
};
